import { useContext, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useForm } from 'react-hook-form';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import UserContext from '../../contexts/UserContext';
import { login } from '../../services/userServices';
import PageHeader from '../Common/PageHeader';
import ForgotPassword from './ForgotPassword';
import './LoginPage.css';
const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const { setUser } = useContext(UserContext);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate();
  const location = useLocation();

  const onSubmit = (formData, e) => {
    login(formData)
      .then((response) => {
        if (response && response.data.status === true) {
          // Store user ID and email in local storage upon successful login
          localStorage.setItem('userData', JSON.stringify(response.data.data));
          localStorage.setItem('userID', response.data.data.user_id);
          localStorage.setItem('userEmail', response.data.data.email);
          toast.success('Login successful');
          setUser(response.data.data);

          const { state } = location;
          navigate(state ? state.from : '/account/profile');
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((err) => {
        // Handle network errors or other unexpected errors
        toast.error('An error occurred while login.');
      });
  };

  return (
    <>
      <Helmet>
        <title>
          Do you want to get Notice of new Arrivals? Signup on Bakumia
        </title>
        <meta
          name="keywords"
          content="new unique items,creative items for home,creative home decor items,creative decorative items,creative products to sell online,creative memories items for sale,creative gift supplies,creative item for home and office,unique products for home,unique home products,unique office wall decor,interesting home products,unique decorative pieces,unique home essentials,funky home decor items,unique home decorative items,unique home office decor,unique household gadgets"
        />
        <meta
          name="description"
          content="If You don`t have account on bakumia.pk, then don`t loss the opportunity of getting notification of new arrivals so just signup your account and login with your own account "
        />
      </Helmet>

      <PageHeader title="Login Page" />
      <div className="container-fluid">
        <div className="row py-3">
          {/* Left Side Content (Visible only on large screens) */}
          <div className="col-lg-6 d-lg-block d-none">
            <h3 className="font-weight-bold mb-4 pb-2">Bakumia</h3>
            <hr className="w-header" />
            <p className="lead w-responsive mx-auto text-muted mt-4 pt-2 mb-5 pe-5">
              To get notification of new arrival of home and kitchen products,
              it is necessary to have account on Bakumia.pk so that we can
              update you with new arrivals timely and you may avail the chance
              of shopping of products as soon as possible.
            </p>
            <div className="w-100 text-center">
              <div className="bg-image__login" />
            </div>
          </div>

          {/* Right Side Form */}
          <section className="col-lg-6 d-flex justify-content-center align-items-center">
            <div className="card shadow-lg w-100">
              {/* Card Body */}
              <div className="card-body p-4 p-md-5">
                <h1 className="fs-4 card-title fw-bold mb-4">Login here</h1>

                <form className="login_form" onSubmit={handleSubmit(onSubmit)}>
                  {/* Email Field */}
                  <div className="mb-3">
                    <label htmlFor="email" className="mb-2 text-muted">
                      E-Mail Address
                    </label>
                    <input
                      id="email"
                      type="email"
                      name="email"
                      placeholder="example@gmail.com"
                      autoFocus
                      autoComplete="username"
                      className="form-control"
                      {...register('email', {
                        required: true,
                        maxLength: 50,
                      })}
                    />
                    {errors.email?.type === 'required' && (
                      <em className="form_error">Please enter your email.</em>
                    )}
                    {errors.email?.type === 'maxLength' && (
                      <em className="form_error">
                        Email should be less than 50 characters.
                      </em>
                    )}
                  </div>

                  {/* Password Field */}
                  <div className="mb-3">
                    <div className="mb-2 w-100 d-flex justify-content-between align-items-center">
                      <label htmlFor="password" className="text-muted">
                        Password
                      </label>
                      <ForgotPassword />
                    </div>
                    <input
                      id="password"
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      placeholder="Enter your password"
                      autoComplete="current-password"
                      className="form-control"
                      {...register('password', {
                        required: true,
                        minLength: 6,
                      })}
                    />
                    {errors.password?.type === 'required' && (
                      <em className="form_error">
                        Please enter your password.
                      </em>
                    )}
                    {errors.password?.type === 'minLength' && (
                      <em className="form_error">
                        Password should be at least 6 characters.
                      </em>
                    )}
                  </div>

                  {/* Show Password + Submit */}
                  <div className="d-flex align-items-center">
                    <div className="form-check">
                      <input
                        type="checkbox"
                        id="showPassword"
                        className="form-check-input"
                        onChange={() => setShowPassword(!showPassword)}
                      />
                      <label
                        htmlFor="showPassword"
                        className="form-check-label"
                      >
                        Show Password
                      </label>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="p-2 button border-0 w-100 mt-2"
                  >
                    Login
                  </button>
                </form>
              </div>

              {/* Card Footer */}
              <div className="card-footer py-3 border-0">
                <div className="text-center">
                  Don't have an account?{' '}
                  <Link
                    to="/register"
                    className="create__new_account text-decoration-underline"
                  >
                    Create new account
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
